<template>
    <video ref="video"
           controls
           @contextmenu.prevent
           class="video-js vjs-default-skin vjs-big-play-centered">
    </video>
</template>

<script>
    export default {
        data: () => ({
            player: null,
            defaultOptions: {
                playbackRates: [0.1, 0.2, 0.5, 1.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始播放。 enlarge > -1
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                //language: 'zh-CN',
                // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: 'video/mp4',
                    src: '' //url地址
                }],
                poster: '', //你的封面地址
                // width: 750,
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    // timeDivider: true,
                    // durationDisplay: true,
                    // durationDisplay: true,
                    // currentTimeDisplay: true,
                    // timeDivider: true,
                    remainingTimeDisplay: false,
                    volumePanel: {
                        inline: false //默认是true,横着的
                    }
                    // timeDivider: true,
                    // durationDisplay: true,
                    // chaptersButton: true,
                    // fullscreenToggle: true  //全屏按钮
                },
                errorDisplay: false,
                posterImage: false,
                bigPlayButton: true,
                textTrackDisplay: false,
            }
        }),
        props: {
            options: {
                type: Object,
                required: true
            },
        },
        methods: {
            error(e) {// 如果视频下载出错 则初始化视频至已缓冲时间的前3秒
                let err = e.error();
                if (err.code === 2) {// 判断是否是网络加载问题
                    let buffTime = e.bufferedEnd() - 6;
                    e.load(this.playerOptions.sources[0].src);
                    e.currentTime(buffTime);
                    e.play();
                } else {
                    this.alert.err(err.message);
                }

            }
        },
        watch: {
            /*options: {
                handler() {
                    console.log('观测到options已发生变化:');
                },
                deep: true
            },*/
            src() {// 侦听视频路径, 当视频路径发生改变时, 重新渲染video路径
                this.player.src(this.src);
                if (this.play) this.player.play();
            },
            play() {// 侦听该属性, 当options的autoplay变为true时 直接播放视频
                if (this.play) this.player.play();
            }
        },
        computed: {
            /*option() {
                console.log('已计算');
                console.log(this.options.sources[0].src);
                // console.log(this.options.sources[0].hasOwnProperty('src'));
                if (this.options.sources[0].src) {
                    return this.options;
                } else {
                    return this.options;
                }

            },*/
            src() {
                return this.options.sources[0].src;
            },
            video() {
                return this.$store.state.video;
            },
            play() {
                return this.options.autoplay;
            }
        },
        mounted() {
            const vm = this;
            this.player = this.$video(this.$refs.video, Object.assign(this.defaultOptions, this.options), function () {
                this.tech_.off('dblclick');
                this.on('play', () => {
                    this.volume(vm.video.volume);
                });

                this.on('volumechange', () => {
                    vm.video.volume = this.volume();
                    window.localStorage.volume = this.volume();
                });

                this.on('error', () => {
                    let err = this.error();
                    if (err.code === 2) {// 判断是否是网络加载问题
                        let buffTime = this.bufferedEnd() - 6;
                        this.load(vm.src);
                        this.currentTime(buffTime);
                        this.play();
                    } else {
                        vm.alert.err(err.message);
                    }
                })
            });
        },
    }
</script>

<style>
    @import "../../../static/css/components/video-js-me.css";
</style>


// WEBPACK FOOTER //
// src/components/BasePlayer/index.vue